import { Component } from '@angular/core';

@Component({
  selector: 'app-how-it-works-section',
  standalone: true,
  imports: [],
  templateUrl: './how-it-works-section.component.html',
  styleUrl: './how-it-works-section.component.scss'
})
export class HowItWorksSectionComponent {

}
